import { BROADCAST_ADD_MEDIA_SOURCE_TO_PROGRAM } from 'actions/Types';
import { withCurrentParams } from 'actions/utils';
import { toggleProgramSource } from '@shoflo/studio-redux/actions';
import {
  isSourceInProgram,
  getStartedOn,
  isAudioVideoSource,
  getSignedUrl
} from 'utils/broadcastSourceHelper';
import setProgram from './setProgram';

/**
 * WEBINAR-25727 - this is in both lite and pro until `toggleProgramSource` is aligned between the apps
 */
export default function addMediaSourceToProgram(source) {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const action = {
        type: BROADCAST_ADD_MEDIA_SOURCE_TO_PROGRAM,
        request: async apiClient => {
          const { program, serverTimeDelta } = getState();
          const { layers } = program;

          const isInProgram = isSourceInProgram(layers, source._id);
          let updatedSource = source;

          if (!isInProgram) {
            if (isAudioVideoSource(source)) {
              updatedSource = {
                ...updatedSource,
                value: {
                  ...updatedSource.value,
                  seek: 0,
                  isPlaying: true,
                  startedOn: getStartedOn(true, serverTimeDelta)
                }
              };

              const response = await apiClient.broadcast.updateSource(
                teamId,
                eventId,
                broadcastId,
                updatedSource._id,
                {
                  value: updatedSource.value
                }
              );

              updatedSource = await getSignedUrl(
                {
                  ...response,
                  team: teamId,
                  event: eventId
                },
                apiClient
              );
            }
          }

          dispatch(toggleProgramSource(updatedSource, setProgram));
        }
      };
      dispatch(action);
    }
  );
}
